import * as applicantInformationCountry from './applicantInformation/applicantCountry';
import * as veteranDesc from './applicantInformation/applicantDescription';
import * as applicantContactInfo from './applicantInformation/applicantContactInfo';
import * as applicantState from './applicantInformation/applicantState';
import * as genderRaceQuestion from './applicantInformation/genderRaceQuestion';
import * as applicantRaceAndEthnicity from './applicantInformation/applicantRaceAndEthnicity';
import * as applicantGender from './applicantInformation/applicantGender';
import * as highestLevelOfEducation from './educationAndEmploymentHistory/highestLevelOfEducation';
import * as currentAnnualSalary from './educationAndEmploymentHistory/currentAnnualSalary';
import * as techIndustryFocusArea from './educationAndEmploymentHistory/techIndustryFocusArea';

export {
  applicantInformationCountry,
  veteranDesc,
  applicantContactInfo,
  applicantState,
  genderRaceQuestion,
  applicantRaceAndEthnicity,
  applicantGender,
  highestLevelOfEducation,
  currentAnnualSalary,
  techIndustryFocusArea,
};
